import * as bestPlateTypes from "./bestPlate.type";

const initialState = {
  votingList: null,
  myPhotos: null,
  winners: null,
  status: { uploadLocked: false, themeName: null, lockMessage: null },
  error: null,
  isLoading: false,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case bestPlateTypes.GET_BEST_PLATE_VOTING_PENDING:
    case bestPlateTypes.SET_BEST_PLATE_VOTE_PENDING:
    case bestPlateTypes.GET_BEST_PLATE_MY_PHOTOS_PENDING:
    case bestPlateTypes.SET_BEST_PLATE_UPLOAD_PENDING:
    case bestPlateTypes.GET_BEST_PLATE_WINNERS_PENDING:
      return { ...state, isLoading: true, error: null };

    case bestPlateTypes.GET_BEST_PLATE_VOTING_FULFILLED:
      return { ...state, isLoading: false, votingList: payload.data };

    case bestPlateTypes.GET_BEST_PLATE_MY_PHOTOS_FULFILLED:
      return { ...state, isLoading: false, myPhotos: payload.data };

    case bestPlateTypes.GET_BEST_PLATE_WINNERS_FULFILLED:
      return { ...state, isLoading: false, winners: payload.data };

    // Status yan bir istek: global loader'ı ve hata ekranını tetiklemez.
    case bestPlateTypes.GET_BEST_PLATE_STATUS_FULFILLED:
      return { ...state, status: payload.data || state.status };

    case bestPlateTypes.SET_BEST_PLATE_VOTE_FULFILLED:
    case bestPlateTypes.SET_BEST_PLATE_UPLOAD_FULFILLED:
      return { ...state, isLoading: false };

    case bestPlateTypes.GET_BEST_PLATE_VOTING_REJECTED:
    case bestPlateTypes.SET_BEST_PLATE_VOTE_REJECTED:
    case bestPlateTypes.GET_BEST_PLATE_MY_PHOTOS_REJECTED:
    case bestPlateTypes.SET_BEST_PLATE_UPLOAD_REJECTED:
    case bestPlateTypes.GET_BEST_PLATE_WINNERS_REJECTED:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default reducer;
